import styled from 'styled-components';

export const FlexRowStyled = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FlexColumnStyled = styled.div`
  display: flex;
  flex-direction: column;
`;
